module.exports = __webpack_public_path__ + "static/dencyu-612189c572054ae840662b855e435ef8.jpg";